import Vue from 'vue'
import Vuex from 'vuex'
import carrinho from './modules/carrinho.js'
import categories from './modules/categories.js'

Vue.use(Vuex);

const state = {
  listaComparacoes: [],
  boasVindas: 'BEM-VINDO A MAIOR LOJA DE NUMISMÁTICA DA AMÉRICA LATINA!',
  categorias: []
}

const getters = {
  comparacoes() {
    return state.listaComparacoes.length
  },
  categorias() {
    return state.categories.list 
  }
  
}

const modules = {
  carrinho,
  categories
}

export default new Vuex.Store({
  state,
  getters,
  modules,
})